import AuthProviderItem from "./auth-provider-item";

// Базовый класс для способов авторизации с попапом для ввода дополнительных данных (например,
// email)
export default class PopupAuthItem extends AuthProviderItem {
  constructor(providerName, menu) {
    super(providerName, menu);
  }

  get popupTemplate() {
    return `
    `;
  }

  _createPopupEl() {
    this.popupEl = videojs.createEl('div', {
      className: 'vjs-chat-soc-net-popup',
    });

    this.popupEl.insertAdjacentHTML('afterbegin', this.popupTemplate);

    return this.popupEl;
  }

  _renderPopupElement() {
    this._createPopupEl();
    this.containerEl.append(this.popupEl);
  }

  _setDomListeners() {
    this.el().addEventListener('click', () => {
      this.showPopup();
    });
    this.popupEl
      .querySelectorAll('.vjs-chat-popup__background, .vjs-chat-popup__close')
      .forEach((el) => {
        el.addEventListener('click', () => {
          this.hidePopup();
        });
      });
    super._setDomListeners();
  }

  showPopup() {
    this.popupEl.classList.add('vjs-chat-popup_show');
  }

  hidePopup() {
    this.popupEl.classList.remove('vjs-chat-popup_show');
  }

  render() {
    this._renderPopupElement();
    super.render();
  }
}
